/**
 * Shared guidance for field labels that have the same meaning across partner
 * modals. A field can still provide its own `data.info` value when its context
 * needs more specific copy.
 */
export const PARTNER_MODAL_FIELD_INFO = {
  "Add Description":
    "Turn this on to add custom text that helps identify the plan.",
  "Application Required":
    "Customers must complete an application before they can enroll.",
  "Billing Cycle": "How often the customer will be billed.",
  "Billing Cycle Anchor":
    "The date used to start and align future billing cycles.",
  "Current Access":
    "The partner staff members who currently have access to this workspace.",
  Coupons: "Apply an existing coupon instead of entering a manual discount.",
  "Days Per Week": "The number of service days included in each week.",
  "Day Slot": "The portion of the day covered by this plan.",
  Deposit: "Require an upfront deposit and enter the amount to collect.",
  "Discount Applied":
    "The discount amount calculated from the selected discount.",
  "Discount Type":
    "Choose whether the discount is a fixed amount or a percentage.",
  "Enable Automatic Follow-up Emails":
    "Send the configured follow-up emails after a customer uses the free trial.",
  "Enable Date Selection":
    "Allow customers to choose an eligible date during registration.",
  "Enable Time Selection":
    "Allow customers to choose an eligible time during registration.",
  "Enable Selecting Specific Drop-In Dates":
    "Allow customers to choose the individual dates they want to attend.",
  "Enable Drop-In Cap":
    "Limit how many drop-in registrations can be sold for each eligible date.",
  "Enable Drop-ins":
    "Allow customers to purchase individual dates instead of the full plan.",
  "Enable Installments":
    "Split the plan total into multiple scheduled payments.",
  "Enable Program Plan Cap":
    "Limit how many registrations can be sold through this pricing plan.",
  "Enable Taxes": "Apply the selected tax plan to charges for this item.",
  "Field Type":
    "The kind of question or input control added to the form.",
  "Form Type": "Choose the form template to add to this listing.",
  Height:
    "The height of the generated iframe; enter a pixel or percentage value.",
  "Include Deposit":
    "Collect a deposit when the customer registers for this plan.",
  "Installment Cycle": "How often each installment payment will be charged.",
  "Internal Description (Optional)":
    "Only partner staff can see this description; it is not shown to customers.",
  "Link Semester Plan":
    "Associate this drop-in option with an existing semester plan.",
  "Make Autopay Mandatory":
    "Require automatic card payments for recurring charges on this plan.",
  "Autopay Mandatory":
    "Require automatic card payments for recurring charges on this plan.",
  "Number of Installments":
    "The total number of payments used to collect the plan price.",
  "Offline Payment":
    "Allow the customer to finish checkout without paying online.",
  "Offline Payments":
    "Allow the customer to finish checkout without paying online.",
  "Premium (%)":
    "The percentage added to the standard price for this option.",
  "Premium Charge":
    "The percentage added to the plan total when installments are used.",
  "Pricing for Package":
    "The amount charged to a customer for one package.",
  "Pricing for Ticket": "The amount charged for one ticket.",
  "Quantity Limit":
    "The number of sessions or classes included in one purchase.",
  "Recurring Payment":
    "Charge the customer on a repeating schedule instead of only once.",
  "Recurring Payments":
    "Charge the customer on a repeating schedule instead of only once.",
  "Replace Time":
    "Use a custom schedule description instead of a fixed start and end time.",
  "Save for future user?":
    "Save this item so partner staff can reuse it on future invoices.",
  "Save Updates for future use?":
    "Apply these updates to the saved item used on future invoices.",
  "Share Transaction Fee":
    "Pass part of the online transaction fee to the customer.",
  "Select Days": "The number of days included in one purchase.",
  "Select Membership":
    "The membership a customer must have to purchase this option.",
  "Select Minutes": "The duration of one session or lesson in minutes.",
  Subscription:
    "Charge membership fees on a recurring schedule instead of only once.",
  "Target Children":
    "Ask the customer to select which child this registration is for.",
  "Tax Plan": "The tax rate and jurisdiction applied to this charge.",
  "Timing (from)": "The time this plan's daily coverage begins.",
  "Timing (to)": "The time this plan's daily coverage ends.",
  "Ticket Quantity":
    "The maximum number of packages or tickets available for purchase.",
  "Tuition Rate":
    "The amount charged each billing cycle, before taxes and discounts.",
  "User Journal":
    "Allow participants to add journal entries to this milestone.",
  "Upload Ability":
    "Allow participants to upload files when completing this milestone.",
  Resources: "Show the Resources section on the participant welcome page.",
  Milestones: "Show the Milestones section on the participant welcome page.",
  Newsfeed: "Show the Newsfeed section on the participant welcome page.",
  Notes: "Show the Notes section on the participant welcome page.",
  Width:
    "The width of the generated iframe; enter a pixel or percentage value.",
  "Adds-On Fee": "Offer optional add-ons with this package or ticket.",
  "Add-ons": "Choose the optional add-ons available with this package."
};

export const getPartnerModalFieldInfo = name =>
  typeof name === "string" ? PARTNER_MODAL_FIELD_INFO[name] : undefined;
